import React from 'react';
import PropTypes from 'prop-types';

const SocialHeader = ({ title, subtitle, onCreatePost, onAutoSchedule }) => (
  <header className="social-header">
    <div>
      <p className="eyebrow">Adflyn Platform</p>
      <h1>{title}</h1>
      <p className="subtitle">{subtitle}</p>
    </div>
    <div className="header-actions">
      <button type="button" className="ghost-btn" onClick={onAutoSchedule}>
        Auto Schedule
      </button>
      <button type="button" className="primary-btn" onClick={onCreatePost}>
        Create Post
      </button>
    </div>
  </header>
);

SocialHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onCreatePost: PropTypes.func,
  onAutoSchedule: PropTypes.func
};

SocialHeader.defaultProps = {
  onCreatePost: () => {},
  onAutoSchedule: () => {}
};

export default SocialHeader;
